var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.text},on:{"input":function($event){return _vm.textInput()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }